// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "span.show-more-less-clickable {\n    cursor:pointer;\n    text-decoration:underline;\n}\n\nspan.show-more-less-clickable:hover{\n    text-decoration:none;\n}", ""]);
// Exports
module.exports = exports;
